<template>
    <div class="comments-wrapper">
        <div class="uk-card uk-card-default comments-parameters">
            <div class="uk-card-header">
                <button class="uk-button uk-button-primary" @click="showCommentsParameters = !showCommentsParameters"
                        type="button">Filter by Comments
                </button>
                <div v-show="showCommentsParameters">
                    <h1>Filter by Comments Parameters</h1>
                    <float-field-input
                            :data="{placeholder: 'agent weather', label:'Enter Key Word'}"
                            @inputevent="(input) => {commentQuery=input}">
                    </float-field-input>

                        <float-field-input @inputevent="(input) => {(input) ? comment_topic=input : comment_topic = null}"
                                           :data="{select: true, placeholder: 'Select a Comment Topic', options: comment_topics, label: 'Select a Topic'}"></float-field-input>

                    <input class="uk-checkbox" value="checked" type="checkbox" v-model="use_related_terms"> Use Related Terms

                                    <div class="uk-flex uk-flex-nowrap uk-flex-between">
                                <font-awesome-icon icon="sad-tear" size="2x" style="color: red; margin-left: 0;"></font-awesome-icon>
                                <font-awesome-icon icon="laugh-beam"size="2x" style="color: darkgreen"></font-awesome-icon>
                      </div>

                    <b-slider v-model="sentiment" :min="0" :max="1" :step="0.1" ticks></b-slider>


                    <div class="uk-button uk-button-secondary uk-button-small" @click="sentimentFinal = sentiment; makeRequest()">
                        Submit</div>
                    </div>
                </div>

                <div v-if="query_terms && commentQuery.length && use_related_terms" class="search-terms">
                    <div v-for="cat in query_terms">
                        <H4> Related Terms Used in Search</H4>
                        <p v-for="term in cat">{{term}}</p>
                    </div>
                </div>
            <div class="uk-card-header">
                <button class="uk-button uk-button-primary" @click="showCommentAnalytics = !showCommentAnalytics"
                type="button">{{showHide}} Comment Analytics
                </button>
            </div>

        </div>
        <br/>

        <div class="uk-card uk-card-default chartcard" v-if="showCommentAnalytics && sentimentTreeMapData.length > 0">
            <div class="uk-card-header">
                <h1>Comment Topic Analysis</h1>
            </div>
            <div class="uk-card-body">
                    <chart-js-tree-map
                        :chartData="sentimentTreeMapData"
                        :explanations="$store.state.documentation.data.metrics"
                        :geographySlug="$route.params.slug"
                        @click="changeTopic"
                    >
                    </chart-js-tree-map>
            </div>
</div>

        <div id="comments" v-if="comments_data && !loading">
			<div v-if="cleanedCommentData.length >= 250">
				<div class="uk-flex-center next-buttons" uk-grid>
					<div>
						<button class="uk-button uk-button-secondary uk-button-small"
								@click="lower_bound=lower_bound-250; upper_bound=upper_bound-250; makeRequest()">Get
							Previous 250 records
						</button>
					</div>
					<div>
						<button class="uk-button uk-button-primary uk-button-small"
								@click="lower_bound=upper_bound; upper_bound=upper_bound+250; makeRequest()">Get Next
							250 records
						</button>
					</div>
				</div>
			</div>

            <div v-for="(c,i) in cleanedCommentData" :ref="'comment-' + i.toString()" class="comment-card" :class="scaledSentiment(c.colorScaleValue)">
                <comment :data="c" :key="i" :search_words="query_terms"
                         @singleSurvey="(input)=>goToSurvey(input)"></comment>
<!--                <appeals-form-->
<!--                    :survey_id="c.survey_id"-->
<!--                    :call_number="c.id"-->
<!--                    :provider_id="c.source.split(' ; ')[0]"-->
<!--                    :eligibility_reason="c.appeals_eligible_reason"-->
<!--                    :appeals_status="c.appeals_status"-->
<!--                    :service_date="c.sc_dt"-->
<!--                    :eligible="c.appeals_eligible"-->
<!--                    :provider_name="c.org_name"-->
<!--                    :provider_email="null"-->
<!--                    :driver_sat="getDriverTotalSat(c.driver_sat)"-->
<!--                    :show_button="true"-->
<!--                    text_button_size="medium"-->
<!--                    @appealSubmitted="updateAfterAppeal"-->
<!--                ></appeals-form>-->
            </div>
        </div>
        <b-loading :active.sync="loading" v-if="!no_data && comments_data" :is-full-page="false"></b-loading>

        <element-spinner v-if="!comments_data && !no_data" name="Comments"></element-spinner>

        <div v-if="no_data">
            <h1>We couldnt find any comments...</h1>
        </div>

    </div>
</template>

<script>

    import apicall from '@/store/apicall'
    import Moment from "moment";
    import elementSpinner from "../theme/elementSpinner"
    import deslug from '@/utils/deslug';
    import Comment from '../theme/Comment'
    import FloatFieldInput from "../theme/Input";
    import BrushChart from "../charts/BrushChart"
    import {colorPaletteStandard, colorPaletteStoplight} from "@/components/charts/colorPaletteStandard";
        import Chip from "../theme/Chips"
    import chartJsTreeMap from "./chartJsTreeMap";
    import AppealsForm from "./AppealsForm";
    import { findIndex } from 'lodash'
    import chartJSTreeMapConverter from "./dashboard_element_data_conversions/chartJSTreeMapConverter";

    var Rainbow = require('rainbowvis.js');
    export default {
        name: "surveyComments",
        components: {
            chartJsTreeMap,
            Comment,
            elementSpinner,
            FloatFieldInput,
            BrushChart,
            Chip,
            AppealsForm
		},
		props: ['slugUpdated'],
		data: function () {

			return {
			    sentimentFinal: null,
                lower_bound: 0,
                loading: false,
                upper_bound: 250,
				comments_data: null,
				no_data: false,
                use_related_terms: true,
                sentiment: [0, 1],
                commentQuery: "",
                singleSurvey: null,
                showCommentsParameters: false,
                showCommentAnalytics: false,
                query_terms: null,
                sentimentColor: null,
                showSurveyTimeSeriesAttributes: ['drivers', 'response_time', 'call_center_operator', 'weather'],
                surveyTimeSeriesMetricType: "count",
                surveyTimeSeriesMetricTypePossibilities: [{display: 'Count of Comments', value: 'count'}, {display: "Average Sentiment Score", value:'avg_sentiment'}],
                sentimentTreeMapData: [],
                comment_topics: [{
			        display: "Loading...",
                    value: false,
                }],
                comment_topic: null,
                topicNameConverter: {
			        battery_test_replace: "BATTERY - TEST/REPLACE",
                    call_center_operator: "PHONE REP",
                    tracking: "STATUS UPDATES/KMI"
                }

			}
		},
        computed: {
            showHide: function() {
                if (this.showCommentAnalytics){
                    return 'Hide'
                }
                return "Show"
            },
            timeConstraints: function() {
		        return this.$store.state.reportFilter.surveys.timeConstraints
            },
            filters: function() {
		        return this.$store.state.reportFilter.surveys.filters
            },
            surveySatFilters: function() {
                return this.$store.state.reportFilter.surveys.satFilter
            },

            survey_params: function() {
                return this.$store.state.surveyParams.data
            },

            isStaff: function() {
                let user_data = this.$store.state.user.data.user
                console.log("USER DATA", user_data)
                return user_data.is_staff
            },


            request: function () {
                let geography = this.$store.state.geography.data;
                return {
                    "slug": geography.slug,
                    "type": this.geographyType,
                    "purpose": 'survey_aggregator',
                    parameters: this.RequestParameters()

                }
            },
            geographyType: function () {
                let geography = this.$store.state.geography.data;
                if (geography.first_name) {
                    return "Driver" // when we get to call center operator we may have to tweak this...

                } else {
                    return geography.type;
                }
            },


            cleanedCommentData: function () {
                let output = []
                if (!this.comments_data) {
                    return output
                } else {

                    let data = this.comments_data.data;
                    if ('query_terms_used' in this.comments_data){
                        this.query_terms = this.comments_data.query_terms_used;
                    }


                    data.forEach(function (el, idx) {
                        output.push({
                            odd: idx % 2,
                            id: el['sc_id'],
                            message: el['q30'],
                            source: el['svc_facl_id'] + ' ; ' + el['driver_name'],
                            time: el['sc_dt'],
                            sat: el['overall_sat'],
                            colorScaleValue: el['sentiment'],
                            colorScaleDomain: [-1, 1],
                            sc_dt: Moment(el['sc_dt']).utc().format('YYYY-MM-DD'),
                            appeals_eligible: el['appeals_eligible'],
                            appeals_status: el['appeals_status'],
                            reroute: el['survey__reroute'],
                            remove: el['survey__remove'],
                            appeals_eligible_reason: el['appeals_eligible_reason'],
                            provider_id: el['survey__emp_driver_id'],
                            provider_email: el['survey__emp_driver__user_email'],
                            driver_sat: el['survey__driver10'],
                            org_name: el['survey__org_business_id__name'],
                            survey_id: el['survey__id'],
                            channel: el['survey__q_chl'],
                        })
                    })
                    return output
                }
            },
        },


        methods: {
            changeTopic(topic){
                console.log("changing topic", topic)
                this.comment_topic=topic.name.toLowerCase()
                this.makeRequest()
            },
            getChipDisplayList(_elem) {

            },

            RequestParameters: function () {

                let parameters = {};
                parameters['filters'] = {}

                parameters['comment_finder'] = 1

                parameters['lower_bound'] = this.lower_bound;
                parameters['upper_bound'] = this.upper_bound;

                for (var filter in this.filters) {
                    if (this.filters[filter] != null) {

                        if (typeof this.filters[filter] == "boolean" || typeof this.filters[filter] == "string") {
                            if (filter == 'reroute' || filter=='remove') {
                                parameters[filter] = this.filters[filter]
                            } else {
                                parameters['filters'][filter] = this.filters[filter]
                            }

                        } else {
                            parameters['filters'][filter + '__in'] = [].concat.apply([], this.filters[filter].map(x => x.value));
                        }
                    }

                }

                if (this.timeConstraints.AppliedSurveyTimeConstraints) {
                    for (var k in this.timeConstraints.AppliedSurveyTimeConstraints) {
                        parameters['filters'][k] = Moment.utc(this.timeConstraints.AppliedSurveyTimeConstraints[k]).format("YYYY-MM-DD")
                    }
                }

                if (this.commentQuery){
                    parameters['search'] = this.commentQuery.split(' ')
                }

                if (this.sentimentFinal){
                    parameters['sentiment'] = {}
                    parameters['sentiment']['sentiment__gte'] = this.sentimentFinal[0]
                    parameters['sentiment']['sentiment__lte'] = this.sentimentFinal[1]

                }

                if (!this.use_related_terms) {
                    parameters['skip_related_words'] = 1
                }

                if (this.surveySatFilters){
                    this.surveySatFilters.forEach(function(s){
                        for (var k in s) {
                            if (s[k]){
                                parameters['filters'][k] = s[k]
                            }

                    }
                    })

                }

                if (this.comment_topic){
                    parameters['topic'] = this.comment_topic
                }

                return parameters
            },

            perc2color(perc) {
                var r, g, b = 0;
                if (perc < 50) {
                    r = 255;
                    g = Math.round(5.1 * perc);
                } else {
                    g = 255;
                    r = Math.round(510 - 5.10 * perc);
                }
                var h = r * 0x10000 + g * 0x100 + b * 0x1;
                return '#' + ('000000' + h.toString(16)).slice(-6);
            },

            goToSurvey: function (directions) {
                let sc_dt = directions.sc_dt.substring(0,10)

                let params = {
                    call_id: directions.sc_id,
                    sc_dt: sc_dt,
                    subsection: 'survey_emulator'
                };

                this.$store.dispatch('setSurveyParams', params)
                // this.$router.push('/dashboard/' + this.$route.params.slug + '?section=survey_section')
            },

            makeRequest: function () {
                this.loading=true
                let _t = this
                apicall.post('/dashboard/', _t.request)
                    .then(function (response) {
                        _t.comments_data = response.data
                        console.log("COMMENT RESPONSE", response.data)
                        if (response.data.length == 0) {
                            _t.no_data = true
                        } else {
                            _t.no_data = false
                        }
                    }).catch((err) => {
                    console.log(err)
                })

                let sentimentTimeSeriesRequest = {
                    "slug": _t.request.slug,
                    "type": _t.request.type,
                    "purpose": 'survey_aggregator',
                    parameters: this.RequestParameters()

                }

                sentimentTimeSeriesRequest['parameters']['topic_aggregator'] = 1
                delete sentimentTimeSeriesRequest['parameters']['comment_finder']
                console.log("TOPIC REQUEST", sentimentTimeSeriesRequest)
                sentimentTimeSeriesRequest['parameters']['topics'] = this.showSurveyTimeSeriesAttributes
                sentimentTimeSeriesRequest['parameters']['metric'] = this.surveyTimeSeriesMetricType
                apicall.post('/dashboard/', sentimentTimeSeriesRequest).then(function(resp){
                    console.log(resp.data, "TOPIC RESPONSE")
                    resp.data = resp.data.map((t)=>{ return {...t, display: ((t.name.toLowerCase() in _t.topicNameConverter) ? _t.topicNameConverter[t.name.toLowerCase()] : t.name).replace(/_/g, ' ')}})
                    _t.sentimentTreeMapData = resp.data
                    _t.comment_topics = [{
                        display: "RESET TO ALL",
                        value: false,
                    }]
                    _t.comment_topics = _t.comment_topics.concat(resp.data.map(x=>{return {display: x.display.toUpperCase(), value: x.name.toLowerCase()}}))
                    console.log(_t.sentimentTreeMapData, "TOPIC MODIFICATION")
                    _t.loading=false
                }).catch((err) => {
                    console.log(err, "TOPIC ERROR")
                })
            },
            getDriverTotalSat(score) {
                let question_options = {
                        1: 'Totally Satisfied',
                        2: 'Satisfied',
                        3: 'Neither Satisfied nor Dissatisfied',
                        4: 'Dissatisfied',
                        5: 'Totally Dissatisfied',
                        6: 'Cant Say'
                    }
                return question_options[score]
            },
            updateAfterAppeal(survey_id) {
                let s_id = findIndex(this.comments_data.data, {survey__id: survey_id.survey_id})
                if (s_id > -1) {
                    this.comments_data.data[s_id]['appeals_eligible'] = false
                    this.comments_data.data[s_id]['appeals_status'] = 'Pending_Approval'
                }
            },
            scaledSentiment: function(color) {
                let val = color
                var myRainbow  = new Rainbow()
                myRainbow.setSpectrum('red', 'yellow', 'green')
                if (val==0.5) {
                    // neutral
                    // return "#D3D3D3"
                    return 'neutral-score'
                } else if (val > 0.5 && val < 0.75) {
                    // sat
                    return 'sat-score'
                    // return '#' + myRainbow.colourAt(val*100)
                } else if (val > 0.75) {
                    // total_sat
                    // return '#' + myRainbow.colourAt(val*100)
                    return 'total-sat-score'
                } else if (val < 0.5 && val > 0.25) {
                    // dis_sat
                    // return '#' + myRainbow.colourAt(val*100)
                    return 'dis-sat-score'
                } else if (val < 0.25) {
                    // total_dis
                    // return '#' + myRainbow.colourAt(val*100)
                    return 'total-dis-score'
                }
                else {
                    return 'neutral-score'
                }
            },
        },

        watch: {
			slugUpdated: function () {
                // this.destroyData()
				// this.makeRequest()
			},
            survey_params() {
			    let _t = this
                // go to the comment you were at before...
			    if (this.survey_params.call_id && this.survey_params.sc_dt) {
			        let id = _t.survey_params.call_id
                    let sc_dt = _t.survey_params.sc_dt
                    console.log(id, sc_dt)
			        let go_to = this.cleanedCommentData.findIndex((c)=> c.id==id)
                    var element = this.$refs['comment-' + go_to.toString()][0]
                    let yOffset = -300
                    let y = (element.getBoundingClientRect().top + window.pageYOffset + yOffset)
                    console.log(y)
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
		},

        mounted() {
            // this.makeRequest()
            // console.log("SURVEY SUBSECTION", this.$route.query.subsection)
            // if (this.$route.query.subsection != 'survey_comments'){
            //     this.$router.replace({query: {subsection: 'survey_comments', section: 'survey_section'}});
            // }


        }
    }
</script>

<style scoped lang="less">
    .search-terms{
        max-height: 200px;
        overflow-y: auto;
    }
        .chartcard {

        margin: 2em;

        .main-chart {
            margin: 0 !important;
        }

        .chart-displayed-fields {
            margin: 18px 10px;
        }

    }
    .comment-card {
        padding: 20px;
        margin: 30px 0;
        border-radius: 7px;
        border: solid thin #ddd;
        -webkit-box-shadow: 0 0 10px 0 #2E2B27;
        box-shadow: 0 0 10px 0 #2E2B27;
        &.total-sat-score {
            background-color: rgba(68, 189, 50,1.0);
            border-color: darken(rgba(68, 189, 50,1.0), 10);
            color: #fff;
        }
        &.sat-score {
            background-color: rgba(76, 209, 55,1.0);
            border-color: darken(rgba(76, 209, 55,1.0), 10);
            color: #fff;
        }
        &.dis-sat-score {
            background-color: lighten(rgba(232, 65, 24,1.0), 10);
            border-color: rgba(232, 65, 24,1.0);
            color: #fff;
        }
        &.total-dis-score {
            background-color: rgba(194, 54, 22, 1.0);
            border-color: darken(rgba(194, 54, 22,1.0), 10);
            color: #fff;
        }
        &.neutral-score {
            background-color: rgba(245, 246, 250,1.0);
        }
    }
</style>
